import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/SessionUserAccount'


// create the fragment store

export class SessionUserAccountStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "SessionUserAccountStore",
			variables: true,
			
		})
	}
}
